import _ from 'lodash';
import * as Actions from './actions';

const initialState = {
  stack: [],
};

// Utility function to locate the right detail item in the stack
// based on the action contents. Can find by stackId or stackIndex.
function findDetailInStack(stack, action) {
  const { stackId = null, stackIndex = null } = action;

  let foundIndex = _.findIndex(stack, { stackId });
  if (!foundIndex && !_.isNil(stackIndex)) {
    foundIndex = stackIndex;
  }

  const found = foundIndex >= 0 ? _.nth(stack, foundIndex) : {};
  return [found, foundIndex];
}

const DetailReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.Detail.DETAIL_DISMISS: {
      const stackIndex = findDetailInStack(state.stack, action)[1];
      return {
        ...state,
        stack: state.stack.slice(0, stackIndex),
      };
    }
    case Actions.Detail.DETAIL_ERROR: {
      const newState = _.cloneDeep(state);
      const [ detail, stackIndex ] = findDetailInStack(newState.stack, action); // eslint-disable-line


      if (detail) {
        detail.error = action.error;
      }

      return newState;
    }
    case Actions.Detail.DETAIL_PRESENT: {
      const newState = _.cloneDeep(state);
      const [ detail, stackIndex ] = findDetailInStack(newState.stack, action); // eslint-disable-line
      const {
        data = {},
        dataType = null,
        stackId,
        clearStack = false,
        parentStackId = null,
      } = action;

      if (clearStack) {
        newState.stack = [];
      }

      // Check to see if it already exists on the stack, remove if so
      if (_.isNumber(stackIndex) && stackIndex >= 0) {
        newState.stack.splice(stackIndex, 1);
      }

      newState.stack.push({
        stackId,
        data,
        dataType,
        collapsed: false,
        loading: false,
        updating: false,
        error: null,
        parentStackId,
      });
      return newState;
    }
    case Actions.Detail.DETAIL_DATA_FETCH_START: {
      const newState = _.cloneDeep(state);
      const [ detail, stackIndex ] = findDetailInStack(newState.stack, action); // eslint-disable-line


      if (detail) {
        detail.loading = true;
        detail.updating = false;
        detail.data = null;
      }
      return newState;
    }
    case Actions.Detail.DETAIL_DATA_FETCH_SUCCESS: {
      const newState = _.cloneDeep(state);
      const [ detail, stackIndex ] = findDetailInStack(newState.stack, action); // eslint-disable-line

      if (detail) {
        detail.updating = false;
        detail.loading = false;
        detail.error = null;
        detail.data = action.data;
        detail.dataType = action.dataType;
      }
      return newState;
    }
    case Actions.Detail.DETAIL_DATA_FETCH_FAILURE: {
      const newState = _.cloneDeep(state);
      const [ detail, stackIndex ] = findDetailInStack(newState.stack, action); // eslint-disable-line

      if (detail) {
        detail.updating = false;
        detail.loading = false;
        detail.error = action.error;
        detail.dataType = action.dataType;
      }
      return newState;
    }
    case Actions.Detail.DETAIL_DATA_UPDATE_START: {
      const newState = _.cloneDeep(state);
      const [ detail, stackIndex ] = findDetailInStack(newState.stack, action); // eslint-disable-line

      if (detail) {
        detail.loading = false;
        detail.updating = true;
      }
      return newState;
    }
    case Actions.Detail.DETAIL_DATA_UPDATE_SUCCESS: {
      const newState = _.cloneDeep(state);
      const [ detail, stackIndex ] = findDetailInStack(newState.stack, action); // eslint-disable-line

      if (detail) {
        detail.updating = false;
        detail.loading = false;
        detail.error = null;
      }
      return newState;
    }
    case Actions.Detail.DETAIL_DATA_UPDATE_FAILURE: {
      const newState = _.cloneDeep(state);
      const [ detail, stackIndex ] = findDetailInStack(newState.stack, action); // eslint-disable-line

      if (detail) {
        detail.updating = false;
        detail.loading = false;
        detail.error = action.error;
      }
      return newState;
    }
    default:
      return state;
  }
};

export default DetailReducer;



// WEBPACK FOOTER //
// ./src/redux/DetailReducer.js